// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import { getNestedByString } from 'helpers/reduxFormFunctions'
import { removeFavoriteFromRadio } from 'redux/modules/pathDetails'

import disableModulation from './disableModulation'
import enableModulation from './enableModulation'

// when a modulation is toggled there are a number of things that must be considered.
const toggleModulationRow = modulationName => (dispatch, getState) => {
  const {
    form,
    pathDetails,
  } = getState()

  const sourceForm = pathDetails.get('sourceForm')

  const formValues = form[sourceForm].values
  const modConfig = getNestedByString(formValues, modulationName)
  const radioName = modulationName.substr(0, modulationName.indexOf(']') + 1)
  const radioConfig = getNestedByString(formValues, radioName)

  const { radioModulationId, txPowerMax } = modConfig
  let { enabled } = modConfig

  const numEnabledMods = radioConfig.modulations.reduce((a, d, i) => {
    if (d.enabled) {
      a++
    }
    return a
  }, 0)

  // 1. if it's the only activated modulation, prevent the lone modulation row from being disabled.
  if (numEnabledMods === 1 && enabled) {
    return false
  }

  // 2. toggle the enabled state before running other checks
  // this way it is clear that we are calculating related values
  // based on the future state of the toggled modulation
  enabled = !enabled

  const power = enabled ? txPowerMax.toString() : ''

  // 3. update this modulation values
  dispatch(change(sourceForm, modulationName, {
    ...modConfig,
    enabled,
    power,
  }))

  // 4. determine the new state of the modulation of interest.
  // multiple values can change based on the new state of the radio's values.
  if (enabled) {
    dispatch(enableModulation(radioName, radioConfig, modConfig))
  } else {
    dispatch(disableModulation(radioName, radioConfig, radioModulationId))
  }

  // 5. finally, if it was a favorite radio, remove the favorite status
  // because the definition of a 'favorite radio' is a radioCode and
  // static, defined set of enabled/disabled modulations.
  if (radioConfig.radioFavoriteId !== null) {
    dispatch(removeFavoriteFromRadio(radioName))
  }
}

export default toggleModulationRow
